import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
} from '@mui/material';
import api from '../../utils/api';

const CreateSuperAdmin = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    address: '',
    city: '',
    state: '',
    longitude: '',
    latitude: '',
    pincode: '',
    pincodeLock: false,
  });

  const handleSubmit = async () => {
    try {
      await api.post(`/api/master/create-super-admin`, form);
      alert('Super Admin created successfully!');
    } catch (err) {
      console.error('Failed to create super admin:', err);
      alert('Creation failed');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Create Super Admin
      </Typography>

      <TextField
        label="Name"
        fullWidth
        margin="normal"
        value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
      />
      <TextField
        label="Email"
        fullWidth
        margin="normal"
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
      />
      <TextField
        label="Password"
        fullWidth
        type="password"
        margin="normal"
        value={form.password}
        onChange={(e) => setForm({ ...form, password: e.target.value })}
      />
      <TextField
        label="Address"
        fullWidth
        margin="normal"
        value={form.address}
        onChange={(e) => setForm({ ...form, address: e.target.value })}
      />
      <TextField
        label="City"
        fullWidth
        margin="normal"
        value={form.city}
        onChange={(e) => setForm({ ...form, city: e.target.value })}
      />
      <TextField
        label="State"
        fullWidth
        margin="normal"
        value={form.state}
        onChange={(e) => setForm({ ...form, state: e.target.value })}
      />
      <TextField
        label="Longitude"
        fullWidth
        margin="normal"
        value={form.longitude}
        onChange={(e) => setForm({ ...form, long: e.target.value })}
      />
      <TextField
        label="Latitude"
        fullWidth
        margin="normal"
        value={form.latitude}
        onChange={(e) => setForm({ ...form, lat: e.target.value })}
      />
      <TextField
        label="Pincode"
        fullWidth
        margin="normal"
        value={form.pincode}
        onChange={(e) => setForm({ ...form, pincode: e.target.value })}
      />
      <Box mt={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.pincodeLock}
              onChange={(e) =>
                setForm({ ...form, pincodeLock: e.target.checked })
              }
            />
          }
          label="Enable Pincode Lock"
        />
      </Box>

      <Button
        variant="contained"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        Create
      </Button>
    </Container>
  );
};

export default CreateSuperAdmin;
